import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { money } from "@/components/fusion/FusionShared";

const API = process.env.REACT_APP_BACKEND_URL;

// Iframe-friendly progress widget for external websites (e.g. a team's own site).
export default function FusionEmbed() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const light = params.get("theme") === "light";
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    const load = () => axios.get(`${API}/api/fusion/public/team/${slug}/widget.json`).then((r) => setD(r.data)).catch(() => setErr(true));
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [slug]);

  const bg = light ? "#ffffff" : d?.primary_color || "#0B1E36";
  useEffect(() => {
    const prev = document.body.style.background;
    document.body.style.background = bg;
    return () => { document.body.style.background = prev; };
  }, [bg]);

  if (err) return <div className="p-4 text-xs text-white/60" data-testid="fusion-embed-error">Campaign not found.</div>;
  if (!d) return <div className="p-4 text-xs text-white/40 animate-pulse" data-testid="fusion-embed-loading">Loading…</div>;

  const pct = Math.max(0, Math.min(100, d.pct_to_goal || 0));
  const fg = light ? "#0B1E36" : "#ffffff";
  const sub = light ? "rgba(11,30,54,.6)" : "rgba(255,255,255,.65)";

  return (
    <a href={d.campaign_url} target="_blank" rel="noopener noreferrer" data-testid="fusion-embed-widget"
      className="block h-full min-h-screen no-underline"
      style={{ background: bg, color: fg, fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif" }}>
      <div className="p-5 md:p-6">
        <div className="flex items-center gap-3">
          {d.logo_url && <img src={d.logo_url} alt="" className="h-9 w-9 object-contain rounded-lg" />}
          <div>
            <div className="text-[11px] tracking-[0.25em] uppercase font-bold" style={{ color: d.secondary_color }}>BioHacker Fusion™ Hit-A-Thon</div>
            <div className="text-base font-extrabold leading-tight" data-testid="fusion-embed-team">{d.team_name || d.event_name}</div>
          </div>
        </div>
        <div className="flex items-baseline justify-between mt-4">
          <div className="text-4xl font-black tracking-tight" data-testid="fusion-embed-raised">{money(d.raised_usd)}</div>
          <div className="text-sm" style={{ color: sub }}>of {money(d.goal_usd)} goal</div>
        </div>
        <div className="h-2.5 rounded-full mt-2.5 overflow-hidden" style={{ background: light ? "rgba(11,30,54,.1)" : "rgba(255,255,255,.12)" }}>
          <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${pct}%`, background: d.secondary_color }} data-testid="fusion-embed-bar" />
        </div>
        <div className="flex justify-between mt-2.5 text-xs" style={{ color: sub }}>
          <span>{pct}% to goal</span>
          <span>{d.athlete_count} athletes · {d.sponsor_count} sponsors</span>
        </div>
        <div className="mt-4 inline-block rounded-full px-4 py-2 text-sm font-extrabold" style={{ background: d.secondary_color, color: "#0B1E36" }}>
          Sponsor an athlete →
        </div>
      </div>
    </a>
  );
}
